/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ResetPasswordRequestFromJSON(json) {
    return ResetPasswordRequestFromJSONTyped(json, false);
}
export function ResetPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        token: !exists(json, 'token') ? undefined : json['token'],
        password: !exists(json, 'password') ? undefined : json['password']
    };
}
export function ResetPasswordRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        token: value.token,
        password: value.password
    };
}
